import {
	BifrostBackendApi,
	BifrostBackendViaCdnApi,
	BifrostBackendNestApi,
	BifrostBackendViaCdnApiV2
} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const { Formats: timeBoxFormats, timebox: timeBox } = appConfig.timeBoxImpl;
const tenantId = appConfig.tenantId;

/*
	Combined endpoints:
	v1.
		1. monitoring
		2. price-rules
		3. global-versions
		4. shops
	v2.
		1. global-versions
		2. upsale-rules
		3. salling holidays
 */

export default {
	async getCombinedDataApiV1(useApiCdnCaching) {
		const bifrostBackendApi = useApiCdnCaching
			? BifrostBackendViaCdnApi
			: BifrostBackendApi;

		const shopParams = {
			onlyActive: true,
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
		};

		const response = await bifrostBackendApi.get("/landingpagedata", {
			params: {
				tenantId,
				shopParams
			}
		});

		return response.data;
	},

	async getCombinedDataApiV2(useApiCdnCaching) {
		// Holidays params
		const holidaysParams = (() => {
			if (!(appConfig.tenantConfig.isSGTenant === true && appConfig.getBusinessModelId() === appConfig.businessModelsEnum.bm2.id)) {
				// SG catering only. It might be better to use a separate FT for this
				return;
			}

			// we only need one week
			const numberOfDays = 6;
			const startDate = timeBox.now().format(timeBoxFormats.YYYY_MM_DD).exec();
			const endDate =	timeBox.now().add({ days: numberOfDays }).format(timeBoxFormats.YYYY_MM_DD).exec();

			return {
				startDate,
				endDate
			};
		})();

		const bifrostBackendApi = useApiCdnCaching
			? BifrostBackendViaCdnApiV2
			: BifrostBackendNestApi;

		const response = await bifrostBackendApi.get("/landingpagedata", {
			params: {
				tenantId,
				...holidaysParams
			}
		});

		return response.data;
	}
};
